export const gregorianToJalali = (gYear, gMonth, gDay) => {
    const date = new Date(gYear, gMonth - 1, gDay);
    const parts = new Intl.DateTimeFormat('en-US-u-ca-persian', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
    }).formatToParts(date);

    let year, month, day;
    for (const part of parts) {
        if (part.type === 'year') year = parseInt(part.value, 10);
        if (part.type === 'month') month = parseInt(part.value, 10);
        if (part.type === 'day') day = parseInt(part.value, 10);
    }

    return { year, month, day };
};

export const jalaliToGregorian = (jYear, jMonth, jDay) => {
    let jy = jYear - 979;
    let jm = jMonth - 1;
    let jd = jDay - 1;

    let j_day_no = 365 * jy + Math.floor(jy / 33) * 8 + Math.floor((jy % 33 + 3) / 4);

    for (let i = 0; i < jm; ++i) {
        j_day_no += (i < 6) ? 31 : 30;
    }

    j_day_no += jd;

    let g_day_no = j_day_no + 79;

    let gy = 1600 + 400 * Math.floor(g_day_no / 146097);
    g_day_no = g_day_no % 146097;

    let leap = true;
    if (g_day_no >= 36525) {
        g_day_no--;
        gy += 100 * Math.floor(g_day_no / 36524);
        g_day_no = g_day_no % 36524;

        if (g_day_no >= 365) {
            g_day_no++;
        }
        leap = false;
    }

    gy += 4 * Math.floor(g_day_no / 1461);
    g_day_no %= 1461;

    if (g_day_no >= 366) {
        leap = false;
        g_day_no--;
        gy += Math.floor(g_day_no / 365);
        g_day_no = g_day_no % 365;
    }

    let i;
    for (i = 0; i < 11; ++i) {
        let days = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][i + 1];
        if (i === 1 && leap) days++;
        if (g_day_no < days) break;
        g_day_no -= days;
    }

    return { year: gy, month: i + 1, day: g_day_no + 1 };
};

export const formatJalaliDate = (year, month, day, hour, minute) => {
    const y = year.toString();
    const m = month.toString().padStart(2, '0');
    const d = day.toString().padStart(2, '0');
    const h = (hour !== undefined ? hour : 0).toString().padStart(2, '0');
    const min = (minute !== undefined ? minute : 0).toString().padStart(2, '0');
    return `${h}:${min} ${y}/${m}/${d}`;
};

export const parseJalaliDate = (dateString) => {
    if (!dateString) return null;

    const parts = dateString.split(' ');
    let datePart, timePart;

    if (parts.length === 2) {
        if (parts[0].includes(':')) {
            timePart = parts[0];
            datePart = parts[1];
        } else {
            datePart = parts[0];
            timePart = parts[1];
        }
    } else {
        datePart = parts[0];
    }

    const dateParts = datePart.split('/');
    if (dateParts.length !== 3) return null;

    const result = {
        year: parseInt(dateParts[0], 10),
        month: parseInt(dateParts[1], 10),
        day: parseInt(dateParts[2], 10)
    };

    if (timePart) {
        const [hour, minute] = timePart.split(':');
        if (hour && minute) {
            result.hour = parseInt(hour, 10);
            result.minute = parseInt(minute, 10);
        }
    }

    return result;
};

export const getCurrentJalaliDate = () => {
    const now = new Date();
    return gregorianToJalali(now.getFullYear(), now.getMonth() + 1, now.getDate());
};
